 <template>
  <div class="container container-fluid">
    <div v-if="showComponentData">
    <div class="row mt-3">
      <!-- FOTOS RELACIONADAS --> 
      <div v-if="isFieldVisible('relationed_files')" class="col-md-6">
        <div v-for="(customField, index) in customFields" :key="index">
          <div class="form-group bordered mb-3">
            <label :for="'relationed_files' + index" class="form-label text-left">
              {{ getFieldDescription('relationed_files') }} {{ index + 1 }}
            </label>
          </div> 
          <div>
            <div>
              <div @click="openCamera(index)" class="btn btn-custom">
                <i class="bi bi-camera-fill"></i> Tomar fotografía
              </div>
              <input
                type="file"
                accept="image/*"
                capture="camera"
                class="form-control inputfile"
                :name="'relationed_files' + index"
                :id="'relationed_files' + index"
                style="display: none;"
                @change="onFileChange(index)"
              />
            </div>
          </div> 
          <div class="btn tbn-block btn-custom my-2" v-if="customField.photoFile" @click="openImageModal(customField.photoFile)">
            Ver Imagen
          </div>
        </div>
        <div @click="addCustomField" class="btn btn-secondary mt-2" title="Agregar componente" >Agregar</div>
      </div>
    </div>
    <hr class="custom-hr mt-4"/>
    </div>
  </div>
  <!-- MODAL -->
  <ShowImagesModal :modalId="'imageModalFormPhotoRetionedFiles'" :currentImage="currentImage" :currentImageName="currentImageName" />
</template>


<script>
import { ref, onMounted } from 'vue';
import ShowImagesModal from '../../modals/ShowImages';
import ImageCompressor from 'image-compressor.js';
import { rotateImageIfNeeded } from '../../../Utils/imageUtils';

export default {
  name: 'FormPhotoRetioned',
  props: {
    data: Object,
  },
  components: {
    ShowImagesModal,
  },
  emits: ['formDataChanged'],
  setup(props, { emit }) {
    const dataCompany = ref(props.data.dataCompaniesForms);
    const dataFormsField = ref(props.data.dataFormsField);
    const showComponentData = ref(false);
    const currentImage = ref(null);
    const currentImageName = ref('');
    const customFields = ref([]);
    const formData = ref([]);

    const openCamera = (index) => {
      const inputElement = document.getElementById('relationed_files' + index);
      inputElement.click();
    };

    const cargarDatos = () => {
      try {
        showComponentData.value = (
          dataCompany.value &&
          dataCompany.value.relationed_files);
          customFields.value.push({ photoFile: null 
        });
      } catch (error) {
        console.error(error);
      }
    };

    const isFieldVisible = (fieldName) => {
      return dataCompany.value && dataCompany.value[fieldName] === 1;
    };

    const getFieldDescription = (fieldNameLabel) => {
      let description = fieldNameLabel;
      const dataFormsFieldsWithData = Object.values(dataFormsField.value);

      dataFormsFieldsWithData[0].forEach((entry) => {
        const field = entry;

        if (field.name === fieldNameLabel) {
          description = field.description;
        }
      });
      return description;
    };

    const openImageModal = (imageFile) => {
      currentImage.value = URL.createObjectURL(imageFile);
      currentImageName.value = imageFile.name;
      $('#imageModalFormPhotoRetionedFiles').modal('show');
    };

    const onFileChange = async (index, file) => {
      const fileInput = document.getElementById('relationed_files' + index);

      const files = fileInput.files;

      try {
        const rotatedFile = await rotateImageIfNeeded(files[0], 90);
        const compressedFile = await compressImage(rotatedFile);
        customFields.value[index].photoFile = compressedFile;

        emitFieldChanged();
      } catch (error) {
        console.error('Error al comprimir la imagen:', error);
      }
    };

    const compressImage = (file) => {
      return new Promise((resolve, reject) => {
        const compressor = new ImageCompressor();
        compressor.compress(file, {
          maxWidth: 800,
          maxHeight: 600,
          quality: 1,
          mimeType: 'image/jpeg',
          success(result) {
            resolve(result);
          },
          error(error) {
            reject(error);
          },
        });
      });
    };

    const emitFieldChanged = () => {
      const newFormData = {};
      customFields.value.forEach((field, index) => {
        newFormData['relationed_files' + index] = field.photoFile;
      });

      formData.value = newFormData;
      emit('formDataChanged', formData.value);
    };

    const addCustomField = () => {
      customFields.value.push({ photoFile: null });
      emitFieldChanged();
    };

    onMounted(() => {
      cargarDatos();
    });

    return {
      showComponentData,
      dataCompany,
      isFieldVisible,
      getFieldDescription,
      dataFormsField,
      openImageModal,
      onFileChange,
      currentImage,
      currentImageName,
      emitFieldChanged,
      addCustomField,
      customFields,
      formData,
      openCamera 
    };
  },
};
</script>
